import { createFileRoute } from '@tanstack/react-router'
import { OrgAnalyticsScreen } from '@/components/analytics/org-analytics-screen'
import { DashboardSkeleton, ViewBarSkeleton } from '@/components/shell/screen-skeletons'
import { requireAnalyticsAccess } from '@/lib/queries/analytics-access'

/**
 * A saved view IS a report with an address: the uuid in the path opens the
 * dashboard into that lens, and the sidebar's rows link straight here.
 */
export const Route = createFileRoute('/o/$org/analytics/$viewId')({
  beforeLoad: ({ context: { queryClient }, params: { org } }) =>
    requireAnalyticsAccess({ queryClient, orgSlug: org }),
  pendingComponent: () => (
    <>
      <ViewBarSkeleton />
      <DashboardSkeleton />
    </>
  ),
  component: AnalyticsViewRoute,
})

function AnalyticsViewRoute() {
  const { viewId } = Route.useParams()
  return <OrgAnalyticsScreen viewId={viewId} />
}
